<template>
  <div>
    <!-- 上传证件照start -->
    <div v-if="!$parent.userCertInfo.id">
      <div class="flex person-profile">
        <div class="load-box" style="width: 295px; height: 413px">
          <div class="load-imgtext flex-x-center">上传本人照片</div>
          <el-upload
            class="avatar-uploader"
            name="file"
            :action="$common_upload"
            :show-file-list="false"
            :headers="{ token: getToken() }"
            :on-success="handleIdPhotoSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              style="width: 295px; height: 413px; margin-top: -60px"
              v-if="idcardModel.id_image"
              :src="idcardModel.id_image"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
          </el-upload>
        </div>

        <!-- <input id="file" type="file" /> -->

        <div
          class="photo-requirements detail-linehead"
          v-html="$parent.initProject.image_tips"
        ></div>
      </div>
      <div class="flex-x-center">
        <button class="confirm" @click="idCardCheck">上传资料</button>
      </div>
    </div>
    <!-- 上传证件照end -->

    <!-- 资料提交start -->

    <div style="width: 80%" v-if="$parent.userCertInfo.id">
      <div class="flex-x-center line-message">
        <form-create v-model="fApi" :rule="rule" :option="option"></form-create>
      </div>
    </div>
    <div class="flex-x-center agree-sign-next">
      <button
        v-if="$parent.userCertInfo.is_cert == 0"
        class="next-step"
        @click="checkFormData()"
      >
        保存
      </button>

      <button
        v-if="
          $parent.userCertInfo.is_cert == 1 &&
          $parent.userCertInfo.confirm_switch == 0
        "
        class="next-step"
        @click="checkFormData()"
      >
        确认
      </button>
      <div
        v-if="
          $parent.userCertInfo.is_cert == 1 &&
          $parent.userCertInfo.confirm_switch == 0
        "
        class="flex-x-y-center"
      >
        <span class="warm-tip-confirm">（确认后不可更改）</span>
      </div>
    </div>
    <!-- 资料提交end -->
  </div>
</template>

<script>
import fileUtil from "@/utils/fileUtil.js";
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";

import { reqIdcardMatch, reqUserCertInfo, reqUserCertConfirm } from "@/api";
export default {
  computed: {
    ...mapState(useMainStore, ["token"]),
  },
  data() {
    return {
      // 组件参数配置
      option: {
        // 显示重置表单按扭
        resetBtn: false,

        submitBtn: false,
        // submitBtn: {
        //   //按钮类型，可选值为primary、ghost、dashed、text、info、success、warning、error或者不设置
        //   type: "primary",
        //   //按钮大小，可选值为large、small、default或者不设置
        //   size: "large",
        //   //按钮形状，可选值为circle或者不设置
        //   shape: undefined,
        //   //开启后，按钮的长度为 100%
        //   long: true,
        //   //设置button原生的type，可选值为button、submit、reset
        //   htmlType: "button",
        //   //设置按钮为禁用状态
        //   disabled: false,
        //   //设置按钮的图标类型
        //   icon: "ios-upload",
        //   //按钮文字提示
        //   innerText: "确认",
        //   //设置按钮为加载中状态
        //   loading: false,
        //   //默认显示
        //   show: true,
        // },
        // 表单提交按扭事件
        onSubmit: (formData) => {
          // alert(JSON.stringify(formData));

          console.log("获取表单中的数据1：", formData);

          reqUserCertConfirm(formData).then((res) => {
            if (res.data.code === 1) {
              successalert(res.data.msg);
              //获取实名认证
              reqUserCertInfo().then((res) => {
                if (res.data.code === 1) {
                  // this.$message.success(res.data.msg);
                  //存储用户信息
                  this.getCertInfo(res.data.data);
                  this.ajaxSetDataFn();

                  this.$router.push("/project");
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });

          //按钮进入提交状态
          //   this.fApi.btn.loading();

          //重置按钮禁用
          //   this.fApi.resetBtn.disabled();

          //按钮进入可点击状态
          //   this.fApi.btn.finish();
        },
      },
      // 实例对象
      fApi: {},
      rule: [
        {
          type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
          field: "truename", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
          className: "user-name-dom", // 设置组件的class属性
          title: "姓名：", // 组件的名称, 选填
          value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
        },

        {
          type: "radio",
          field: "gender",
          title: "性 别：",
          options: [
            {
              label: "男",
              value: 1,
            },
            {
              label: "女",
              value: 2,
            },
          ],
        },
        {
          type: "select",
          field: "type",
          title: "证件类型：",
          options: [
            {
              label: "身份证",
              value: 1,
            },
            {
              label: "香港地区证件",
              value: 2,
            },
            {
              label: "澳门地区证件",
              value: 3,
            },
            {
              label: "台湾地区证件",
              value: 4,
            },
          ],
        },
        {
          type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
          field: "id_card", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
          className: "user-name-dom", // 设置组件的class属性
          title: "证件编号：", // 组件的名称, 选填
          value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
          props: {
            disabled: false,
            readonly: false,
          },
        },
        {
          type: "DatePicker", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
          field: "birthday", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
          className: "user-name-dom", // 设置组件的class属性
          title: "出生日期：", // 组件的名称, 选填
          value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
          //   value: "2018-02-20 23:23:23",
          props: {
            type: "date",
            format: "yyyy-MM-dd",
            placeholder: "请选择出生日期",
          },
        },
        {
          type: "input", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
          field: "address", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
          className: "user-name-dom", // 设置组件的class属性
          title: "家庭地址：", // 组件的名称, 选填
          value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
          props: {
            disabled: false,
            readonly: false,
          },
        },
        {
          type: "select", // 生成组件的名称(就是表单的名称：如input，radio，checkbox，select，slider等)
          field: "nation", // 表单组件的字段名称(就是表单的name属性，注：该必须唯一),自定义组件可以不配置
          className: "user-name-dom", // 设置组件的class属性
          title: "民族：", // 组件的名称, 选填
          value: "", // 表单组件的字段值(就是表单的value值),自定义组件可以不用设置
          options: [
            {
              value: "01",
              label: "汉族",
              disabled: false,
            },
            {
              value: "02",
              label: "蒙古族",
              disabled: false,
            },
            {
              value: "03",
              label: "回族",
              disabled: false,
            },
            {
              value: "04",
              label: "藏族",
              disabled: false,
            },
            {
              value: "05",
              label: "维吾尔族",
              disabled: false,
            },
            {
              value: "06",
              label: "苗族",
              disabled: false,
            },
            {
              value: "07",
              label: "彝族",
              disabled: false,
            },
            {
              value: "08",
              label: "壮族",
              disabled: false,
            },
            {
              value: "09",
              label: "布依族",
              disabled: false,
            },
            {
              value: "10",
              label: "朝鲜族",
              disabled: false,
            },
            {
              value: "11",
              label: "满族",
              disabled: false,
            },
            {
              value: "12",
              label: "侗族",
              disabled: false,
            },
            {
              value: "13",
              label: "瑶族",
              disabled: false,
            },

            {
              value: "14",
              label: "白族",
              disabled: false,
            },
            {
              value: "15",
              label: "土家族",
              disabled: false,
            },
            {
              value: "16",
              label: "哈尼族",
              disabled: false,
            },
            {
              value: "17",
              label: "哈萨克族",
              disabled: false,
            },
            {
              value: "18",
              label: "傣族",
              disabled: false,
            },
            {
              value: "19",
              label: "黎族",
              disabled: false,
            },
            {
              value: "20",
              label: "傈僳族",
              disabled: false,
            },
            {
              value: "21",
              label: "佤族",
              disabled: false,
            },
            {
              value: "22",
              label: "畲族",
              disabled: false,
            },
            {
              value: "23",
              label: "高山族",
              disabled: false,
            },
            {
              value: "24",
              label: "拉祜族",
              disabled: false,
            },
          ],
          props: {
            disabled: false,
            readonly: false,
            multiple: true,
            placeholder: "请选择",
            notFoundText: "无匹配数据",
            placement: "bottom",
            multiple: false,
          },
        },
      ],
      idcardModel: {
        front_image: "",
        back_image: "",
        id_image: "",
        truename: "",
        mobile: "",
        id_card: "",
        address: "",
        gender: "",
        nation: "",
        birthday: "",
        type: "",
        confirm_switch: 0,
      },
    };
  },
  mounted() {
    console.log("home", this.$parent.userCertInfo);
    // this.getCert();
    this.ajaxSetDataFn();
  },
  methods: {
    checkFormData() {
      reqUserCertConfirm(this.fApi.formData()).then((res) => {
        this.$message.success("test");
        if (res.data.code === 1) {
          //获取实名认证
          reqUserCertInfo().then((res) => {
            if (res.data.code === 1) {
              //存储用户信息
              this.getCertInfo(res.data.data);
              this.ajaxSetDataFn();
              // that.$router.push("/home");
            }
          });
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    ...mapActions(useMainStore, {
      getCertInfo: "updateUserCertInfo",
    }),
    // 设置表单数据
    ajaxSetDataFn() {
      if (this.$parent.userCertInfo.id) {
        this.idcardModel = this.$parent.userCertInfo;
        this.fApi.setValue(this.idcardModel);
        if (this.$parent.userCertInfo.confirm_switch == 1) {
          this.fApi.disabled(true);
          this.fApi.btn.show(false);
        }
      }
    },
    getCert() {
      let that = this;
      //获取实名认证
      reqUserCertInfo().then((res) => {
        if (res.data.code === 1) {
          //存储用户信息
          that.getCertInfo(res.data.data);
          //显示数据
          this.ajaxSetDataFn();
          // that.$router.push("/home");
        } else {
          that.getCertInfo({});
        }
      });
    },
    //报名流程
    idCardCheck() {
      let that = this;
      reqIdcardMatch(that.idcardModel).then((res) => {
        if (res.data.code === 1) {
          //获取实名认证
          reqUserCertInfo().then((res) => {
            if (res.data.code === 1) {
              //存储用户信息
              that.getCertInfo(res.data.data);
              that.ajaxSetDataFn();
              // that.$router.push("/home");
            }
          });
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getToken() {
      return this.token.replace(/\"/g, "");
    },
    //身份证正面
    handleIdFrontSuccess(res, file) {
      this.idcardModel.front_image = res.data.fullurl;
    },
    //身份证反面
    handleIdBackSuccess(res, file) {
      this.idcardModel.back_image = res.data.fullurl;
    },
    //证件照
    handleIdPhotoSuccess(res, file) {
      this.idcardModel.id_image = res.data.fullurl;
    },
    // 限制上传图片
    async beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpg";

      const isLt2M = file.size / 1024 < 15;
      const width = 295; // 限制图片尺寸为295X413
      const height = 413;
      if (!extension) {
        this.$message({
          message: "上传文件只能是 jpg格式!",
          type: "warning",
        });
        return Promise.reject();
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 15Kb!",
          type: "warning",
        });
        return Promise.reject();
      }

      function asyncGetPx() {
        return new Promise((resolve, reject) => {
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);
          img.onload = () => {
            console.log(img.width);
            if (img.width == width && img.height == height) {
              resolve(true);
            } else {
              resolve(false);
            }
          };
        });
      }
      let isPx = await asyncGetPx();
      if (!isPx) {
        this.$message.warning("请上传 295*413的图片");
        return Promise.reject();
      } else {
        return Promise.resolve();
      }
    },

    // beforeAvatarUpload(file) {
    //   const type = file.type.split("/")[1];
    //   const arr = ["jpg"];
    //   let isJPG = true;
    //   arr.find((item) => {
    //     if (item == type) {
    //       return (isJPG = true);
    //     } else {
    //       return (isJPG = false);
    //     }
    //   });

    //   const isLt2M = file.size / 1024  < 10;
    //   if (!isJPG) {
    //     this.$message.error("上传头像图片只能是 JPG 格式!");
    //     return isJPG;
    //   } else if (!isLt2M) {
    //     this.$message.error("上传头像图片大小不能超过 10KB!");
    //     return isLt2M;
    //   } else {

    //   }
    // },
    handleSelect(item) {
      console.log(item);
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    routeHop(url) {
      this.$router.push(url);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style scoped>
.warm-tip-confirm {
  margin: 0px 0px 20px 10px;
  color: rgb(223, 168, 105);
  letter-spacing: 0.5px;
  font-weight: 350;
}

.next-step:hover {
  transform: scale(1.1);
  cursor: pointer;
}

.next-step {
  color: #b8000d;
  border: #b8000d 1px solid;
  width: 60px;
  padding: 5px;
  height: 30px;
  border-radius: 3px;
  margin-bottom: 20px;
  background-color: white;
}

.confirm {
  width: 80px;
  height: 40px;
  border-radius: 4px;
  background-color: rgb(231, 228, 228);
  border: none;
  margin: 40px 0px 0px 0px;
}

.id-text {
  font-size: 16px;
  color: rgb(39, 36, 36);
  margin-top: 30px;
  margin-left: 10px;
  font-weight: 300;
}

.avatar-uploader-icons {
  font-size: 28px;
  color: black;
  width: 300px;
  height: 120px;
  line-height: 100px;
  text-align: center;
}

.load-boxid {
  background-color: #f6f4f4;
  color: rgb(255, 255, 255);
  border: 1px rgb(216, 207, 207) dotted;
  margin: 30px 10px;
  height: 200px;
  border-radius: 4px;
  width: 300px;
}

.inline-input {
  width: 300px;
}

.load-box {
  background-color: #f6f4f4;
  color: rgb(255, 255, 255);
  border: 1px rgb(216, 207, 207) dotted;
  margin: 0px 10px;
  height: 200px;
  width: 400px;
  border-radius: 4px;
}

.load-imgtext {
  color: black;
  margin: 20px;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: black;
  width: 300px;
  height: 120px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.load-img {
  margin-left: 10%;
}

.basics {
  font-size: 16px;
  color: black;
}

.sill-t {
  width: 1px;
  height: 30px;
  background-color: rgb(239, 232, 232);
  margin-top: 10px;
}

.sill {
  width: 100%;
  height: 1px;
  background-color: rgb(239, 232, 232);
  margin: 20px 0px;
}

.applyicon-fontsize {
  font-size: 25px;
}

.title-fontsize {
  font-size: 20px;
  height: 60px;
}

.line-messages {
  margin-top: 20px;
}

.line-message {
  margin-top: 60px;
}

.message-input {
  width: 300px;
}

.message {
  color: rgb(145, 135, 135);
  width: 80px;
  font-size: 16px;
  font-weight: 300;
}

.detail-linehead {
  line-height: 20px;
  letter-spacing: 1px;
}

.bule-detail {
  color: #539fea;
  font-weight: 300;
}

.photo-detail-red {
  color: red;
  font-weight: 300;
}

.explain {
  margin-top: 20px;
}

.photo-detail {
  color: rgb(145, 135, 135);
  font-weight: 300;
  margin-top: 10px;
}

.photo-re {
  font-size: 10px;
  font-weight: 500;
}

.photo-requirements {
  margin-left: 60px;
}

.person-profile {
  margin-top: 20px;
}

.two-menu {
  margin-top: 30px;
  font-weight: 500;
}

.notice {
  margin: 0px 30px;
  color: #539fea;
  font-weight: 600;
  font-size: 19px;
}

.off {
  color: #539fea;
  font-size: 18px;
}

/* .two-icon {
  margin: 20px 40px;
} */
.load-nows {
  color: #539fea;
  border: none;
  font-size: 16px;
}

.load-now {
  /* margin-right: 30px; */
  margin-top: 15px;
  color: #000;
}

.register {
  font-size: 20px;
  margin-top: 60px;
}

.con-register {
  width: 82%;
  /* height: 780px; */
  background-color: #fff;
  margin-top: 30px;

  border-radius: 4px;
}

/* .title-img {
  width: 40px;
  height: 40px;
  margin: 10px 20px 10px 50px;
  border-radius: 30px;
} */
/* .re-bigbox {
  background-color: #f0f1f1;
  width: 80%;
  height: 900px;
  min-width: 800px;
  /* margin-top: 40px; */
/* border-radius: 10px; */
/* } */
.re-title {
  height: 10%;
  font-size: 18px;
  font-weight: 500;
  color: #539fea;
}
</style>
